module.exports = __webpack_public_path__ + "static/media/edit-admin.c20f0542.svg";